export default "__VITE_ASSET__CqkJrtg6__"